import './respmenu.css';

export default class RespMenu {

  constructor(el) {
    this.el = document.querySelector('body');
    this.navEl = el;
    this.list = this.navEl.innerHTML;
    this.render();
    this.controller();
  }

  toggleMenu(e) {
    if (this.menu.className.indexOf('show') > -1) {
      this.menu.className = 'mobile__menu';
    } else {
      this.menu.className = 'mobile__menu show';
    }
    e.preventDefault();
    e.stopPropagation();
  }

  hideMenu(e) {
    e.preventDefault();
    e.currentTarget.className = 'mobile__menu';
  }

  controller() {
    this.mBtn.addEventListener('click', (e)=> this.toggleMenu(e));
    this.menu.addEventListener('click', (e)=> this.hideMenu(e));
    const hrefs = this.menu.querySelectorAll('a');
    let i = 0;
    while(i < hrefs.length) {
      let el = hrefs[i];
      i += 1;
      el.addEventListener('click', (e)=> {
        e.stopPropagation();
      });
    }
  }

  render() {
    this.menu = document.createElement('div');
    this.menu.className = 'mobile__menu';
    this.menu.innerHTML = `<ul>${this.list}</ul>`;
    this.mBtn = document.createElement('div');
    this.mBtn.className = 'mobile__menu_btn';
    this.mBtn.innerHTML = [
      '<span></span>',
      '<span></span>',
      '<span></span>'
    ].join('');
    this.menu.appendChild(this.mBtn);
    this.el.appendChild(this.menu);
  }
}



// WEBPACK FOOTER //
// ./modules/RespMenu/index.js